import { render, staticRenderFns } from "./BannerIcon.vue?vue&type=template&id=1ac2b56e&scoped=true"
import script from "./BannerIcon.vue?vue&type=script&lang=js"
export * from "./BannerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac2b56e",
  null
  
)

export default component.exports